import { createAction, props } from '@ngrx/store';
import { Payout } from 'src/app/models/payout.model';
import { PaginationFilterInput } from 'src/app/models/request-models/pagination-review-response';
import { ChangePayoutStatusRequest } from 'src/app/models/request-models/change-payout-status-request';
import { ApiResponse } from 'src/app/models/response-model/api-response';

export enum PayoutActionTypes {
  GET_PAYOUTS = '[Payouts] Get Payouts',
  GET_PAYOUTS_SUCCESS = '[Payouts] Get Payouts Success',
  GET_PAYOUTS_FAILURE = '[Payouts] Get Payouts Failure',

  CREATE_PAYOUT = '[Payouts] Create Payout',
  CREATE_PAYOUT_SUCCESS = '[Payouts] Create Payout Success',
  CREATE_PAYOUT_FAILURE = '[Payouts] Create Payout Failure',

  CHANGE_PAYOUT_STATUS = '[Payouts] Change Payout Status',
  CHANGE_PAYOUT_STATUS_SUCCESS = '[Payouts] Change Payout Status Success',
  CHANGE_PAYOUT_STATUS_FAILURE = '[Payouts] Change Payout Status Failure',

  GET_WALLET_BALANCE = '[Payouts] Get Wallet Balance',
  GET_WALLET_BALANCE_SUCCESS = '[Payouts] Get Wallet Balance Success',
  GET_WALLET_BALANCE_FAILURE = '[Payouts] Get Wallet Balance Failure',

  RESET_PAYOUTS = '[Payouts] Reset Payouts',
}

export const getPayouts = createAction(
  PayoutActionTypes.GET_PAYOUTS,
  props<{ request: Partial<PaginationFilterInput> }>(),
);

export const getPayoutsSuccess = createAction(
  PayoutActionTypes.GET_PAYOUTS_SUCCESS,
  props<{ data: ApiResponse<Payout[]> }>(),
);

export const getPayoutsFailure = createAction(PayoutActionTypes.GET_PAYOUTS_FAILURE, props<{ error: any }>());

export const createPayout = createAction(
  PayoutActionTypes.CREATE_PAYOUT,
  props<{ request: Payout; searchData: Partial<PaginationFilterInput> }>(),
);

export const createPayoutSuccess = createAction(
  PayoutActionTypes.CREATE_PAYOUT_SUCCESS,
  props<{ data: ApiResponse<Payout> }>(),
);

export const createPayoutFailure = createAction(PayoutActionTypes.CREATE_PAYOUT_FAILURE, props<{ error: any }>());

export const changePayoutStatus = createAction(
  PayoutActionTypes.CHANGE_PAYOUT_STATUS,
  props<{ request: ChangePayoutStatusRequest; file?: File; filterRequest: Partial<PaginationFilterInput> }>(),
);

export const changePayoutStatusSuccess = createAction(
  PayoutActionTypes.CHANGE_PAYOUT_STATUS_SUCCESS,
  props<{ data: ApiResponse<boolean> }>(),
);

export const changePayoutStatusFailure = createAction(
  PayoutActionTypes.CHANGE_PAYOUT_STATUS_FAILURE,
  props<{ error: any }>(),
);

export const getWalletBalance = createAction(PayoutActionTypes.GET_WALLET_BALANCE);

export const getWalletBalanceSuccess = createAction(
  PayoutActionTypes.GET_WALLET_BALANCE_SUCCESS,
  props<{ balance: number }>(),
);

export const getWalletBalanceFailure = createAction(
  PayoutActionTypes.GET_WALLET_BALANCE_FAILURE,
  props<{ error: any }>(),
);

export const resetPayouts = createAction(PayoutActionTypes.RESET_PAYOUTS);
